import { AppError } from './app-error.model';

export interface ApiMeta {
  [key: string]: unknown;
}

export interface ApiResponse<T> {
  status: boolean;
  message: string[];
  data: T;
  meta: ApiMeta | null;
}

export interface PaginationMeta {
  page: number;
  pageSize: number;
  total: number;
}

export interface PaginatedApiResponse<T> extends Omit<ApiResponse<T[]>, 'meta'> {
  meta: PaginationMeta;
}

export function unwrap<T>(response: ApiResponse<T>): T {
  if (!response.status) {
    const error: AppError = { statusCode: 200, title: 'Error', messages: response.message };
    throw error;
  }
  return response.data;
}
